import {Injectable} from '@angular/core';
import {catchError, switchMap} from 'rxjs/operators';
import {throwError, Observable} from 'rxjs';
import {SearchOptionsResponse} from '../models/SearchOptionsResponse.model';
import {HttpService} from 'src/app/services/http.service';
import {SearchOptionsRequest} from '../models/SearchOptionsRequest.model';

/**
 * @typeParam T The class to be used for the full details.
 * @typeParam S The class to be used for list items (basic details only). Can be the same class as the full details.
 */
@Injectable({
  providedIn: 'root'
})
export abstract class AbstractRestService<T, S> {
  // protected abstract readonly baseEndpoint: string;
  protected abstract readonly baseEndpoint$: Observable<string>;

  constructor(protected http: HttpService) {
  }

  protected getSearchOptionsToQuerystring(options: SearchOptionsRequest): string {
    const filter = encodeURIComponent(options.filter);
    return `?filter=${filter}&sortOrder=${options.sortOrder}&orderBy=${options.orderBy}&pageNumber=${options.pageNumber}&pageSize=${options.pageSize}`;
  }

  public create(model: T): Observable<T> {
    return this.baseEndpoint$.pipe(
      switchMap(baseEndpoint => this.http.postTyped<T>(baseEndpoint, model)),
      catchError(err => {
        return throwError(err);
      })
    );
  }

  public update(id: number, model: T): Observable<T> {
    return this.baseEndpoint$.pipe(
      switchMap(endpoint => this.http.putTyped<any>(endpoint + id, model)),
      catchError(err => {
        return throwError(err);
      })
    );
  }

  public delete(id: number): Observable<void> {
    return this.baseEndpoint$.pipe(
      switchMap(endpoint => this.http.deleteTyped<void>(endpoint + id)),
      catchError(err => {
        return throwError(err);
      })
    );
  }

  public getList(options: SearchOptionsRequest = null): Observable<SearchOptionsResponse<S>> {
    const querystring = options ? this.getSearchOptionsToQuerystring(options) : '';

    return this.baseEndpoint$.pipe(
      switchMap(endpoint => this.http.getTyped<SearchOptionsResponse<S>>(endpoint + querystring)),
      catchError(err => {
        return throwError(err);
      })
    );
  }


  public getById(id: number): Observable<T> {
    return this.baseEndpoint$.pipe(
      switchMap(endpoint => this.http.getTyped<T>(endpoint + id)),
      catchError(err => {
        return throwError(err);
      })
    );
  }
}
